export default __webpack_public_path__ + "static/media/Louis-Blue.1ac59517.jpg";